import React from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { useMapEditing } from "../../../../components/SiteMap/utils/routing";
import DefaultRoute from "../../../../components/SiteMap/routes/DefaultRoute";
import { usePaywall } from "../../../../components/SiteMap/contexts/PaywallContext";

const SiteMapDefault = () => {
  const { setEditing } = useMapEditing();
  const { siteMapCreditsUsed } = usePaywall();

  return (
    <>
      <PortalButtonHeader>
        <Link to="export">
          <button className="px-6 py-2.5 rounded-xl font-bold text-sm cursor-pointer bg-snow-gray hover:opacity-80 active:opacity-40 mr-4">
            Export Map
          </button>
        </Link>
        <button
          disabled={siteMapCreditsUsed}
          onClick={() => setEditing(true)}
          className={`px-6 py-2.5 rounded-xl font-bold text-snow-white text-sm ${siteMapCreditsUsed ? "cursor-not-allowed bg-gray-400" : "cursor-pointer bg-snow-blue-3 hover:opacity-80 active:opacity-40"}`}
        >
          Edit
        </button>
      </PortalButtonHeader>
      <DefaultRoute />
    </>
  );
};

export default SiteMapDefault;

export const PortalButtonHeader = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const portalTarget = document.getElementById("site-map-header-portal");
  return portalTarget ? createPortal(children, portalTarget) : null;
};
